import React from 'react';
import { DataTable, FormGroup, TextArea } from '@punchcard/core';
import ThreeStarsLogo from '@punchcard/core/assets/three-stars.png';
import { RowInfo } from 'react-table';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PageButton from '@punchcard/core/components/WorkSample/PageButton';

interface IProps {
	editComments?: boolean;
	isWorkSampleReview?: boolean;
	isPreparing?: boolean;
}
function Whiteboard(props: IProps) {
	const { t } = useTranslation();
	const { editComments = true, isWorkSampleReview, isPreparing } = props;
	const methods = useFormContext<StudentWorkSampleDTO>();
	const sample = methods.getValues();
	const handleAddToSample = async () => {
		if (sample && sample.includeWhiteboard === true) {
			methods.setValue('includeWhiteboard', false);
		} else {
			methods.setValue('includeWhiteboard', true);
		}
	};
	const documentsWithIUrl = React.useMemo(() =>
		sample?.documents
			.map(doc => ({
				...doc,
				gradeString: `${doc.gradeReceived ?? '##'}/${doc.gradeValue ?? '##'}`,
			}))
			.filter(doc => doc.documentFileUrl !== null && doc.gradeValue !== undefined)
	, [sample?.documents]);

	const columns = [
		{
			accessor: 'gradeValue',
			show: false,
		},
		{
			accessor: 'gradeReceived',
			show: false,
		},
		{
			accessor: 'combined',
			Header: () => <span>{t('assessment.assessment')}</span>,
			Cell: (rowValue: RowInfo) => (
				`${rowValue.original.itemType} ${rowValue.original.activityNumber ?? ''}${rowValue.original.activityName ? ': ' + rowValue.original.activityName : ''}`
			),
			Footer: <span className="ps-3 fw-bold">{t('wip.final_grade')}</span>
		},
		{
			width: 100,
			accessor: 'gradeString',
			className: 'justify-content-end',
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			Footer: (info: any) => {
				const total = info.data?.reduce((sum: number, row: { gradeValue: number | undefined }) => sum + (row.gradeValue || 0), 0);
				const received = info.data?.reduce((sum: number, row: { gradeReceived: number | undefined }) => sum + (row.gradeReceived || 0), 0);
				return <span className="fw-bold me-2">{received ?? '##'}/{total ?? '##'}</span>;
			},
		}
	];

	return (
		<div className="position-relative mb-2">
			{!sample.includeWhiteboard &&
				<div id="divoverlay" className="workSampleOverlay"></div>
			}
			<div className="d-flex flex-column flex-fill mx-auto text-white p-4" style={{ backgroundColor: '#177791', width: '850px' }}>
				<div className="mb-2 d-flex flex-row">
					<h4>
						{sample?.courseName}
					</h4>
					<img src={ThreeStarsLogo} alt="Star Logo" height="40px" className="d-inline-block px-2" />
				</div>
				<div className="mb-3">
					<span className="me-3">{sample?.courseUnitName}</span>
					<span className="border border-white"></span>
					<span className="mx-3">{sample?.courseNumber}</span>
				</div>
				<h6>{`${sample?.firstName} ${sample?.lastName} `}</h6>
			</div>
			<div className="d-flex flex-column bg-white flex-fill p-4 pt-3">
				<Controller
					control={methods.control}
					name="workSampleComment"
					render={({ field, fieldState }) => (
						<FormGroup fieldState={fieldState}>
							{editComments ?
								<TextArea {...field} rows={3} placeholder={t('wip.comment_placeholder')} /> :
								<div className="border rounded py-2 px-3" style={{ minHeight: '100px', whiteSpace: 'pre-line' }}>{field.value}</div>
							}
						</FormGroup>
					)}
				/>
				<DataTable
					data={documentsWithIUrl}
					columns={columns}
					resizable={false}
					sortable={false}
					pageSize={50}
					filterable={false}
					showPagination={false}
					noDataText={t('wip.no_data_found')}
					className="z-0 noSort-data-table noHover-datatable striped-data-table"
				/>
				{isWorkSampleReview &&
					<PageButton handleAddToSample={handleAddToSample} includeItem={sample.includeWhiteboard} isFinalGrade={true} isPreparing={isPreparing} />
				}

			</div>

		</div>

	);
}

export default Whiteboard;


